export default "__VITE_ASSET__2AoIx$Iv__"